import { render, staticRenderFns } from "./EmbedSidebarNuggets.vue?vue&type=template&id=f2286098&scoped=true"
import script from "./EmbedSidebarNuggets.vue?vue&type=script&lang=js"
export * from "./EmbedSidebarNuggets.vue?vue&type=script&lang=js"
import style0 from "./EmbedSidebarNuggets.vue?vue&type=style&index=0&id=f2286098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2286098",
  null
  
)

export default component.exports